var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dialog-layer"},[_c('div',{staticClass:"layer-header"},[_vm._t("layer-header-front")],2),_vm._v(" "),_c('div',{staticClass:"layer-body"},[_vm._t("layer-body-front"),_vm._v(" "),_c('router-view')],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-32c14380","hasScoped":false,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/v2/zdydialog.vue
// module id = 1256
// module chunks = 72